/**
 * Mock-Fixture Pattern für Phase-2-Views.
 *
 * Aktivierung: setze `VITE_USE_FIXTURES=1` in `.env.local`.
 *  → `useFixturesMode()` returnt true; Page-Hooks laden Fixture statt API.
 *
 * Vorteil: UI-Iteration ohne Backend-Verfügbarkeit, deterministischer
 * Vitest- & Playwright-Test-Lauf, schnelles Demo-Setup für Stakeholder.
 *
 * Naming-Konvention: pro View ein `fixture.js` in deren Folder, das ein
 * deterministisches Mock-Objekt zurückgibt. Cross-View-shared Mocks (z. B.
 * Sample-User, Sample-Brand) leben unter `src/orbit/api/fixtures/`.
 */

export function useFixturesMode() {
  return import.meta.env.VITE_USE_FIXTURES === '1';
}

/**
 * Async-Schein-Latenz für realistisches Loading-Verhalten in der UI.
 * Default 250ms — schnell genug für Tests, sichtbar genug für Devs.
 */
export function fixtureDelay(ms = 250) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
